import { NgModule } from '@angular/core';
import { GlobalSearchComponent } from './global-search.component';

import { SearchModuleModule, UserHistoryModule } from '@soleran/audit';
// import { AppCommonModule } from '../common/common.module';
import { RouterModule } from '@angular/router';

import { GlobalSearchHistoryResultsComponent } from './global-search-history-results/global-search-history-results.component';
import { GlobalSearchRecordResultsComponent } from './global-search-record-results/global-search-record-results.component';
import { GlobalSearchService } from './global-search.service';
import { AdvancedSearchComponent } from './advanced-search/advanced-search.component';
import { AdvancedSearchDialogComponent } from './advanced-search/advanced-search-dialog.component';
import { AdvancedSearchService } from './advanced-search/advanced-search.service';

// eslint-disable-next-line max-len
import { AdvancedSearchHistoryTableComponent } from './advanced-search/advanced-search-history-table/advanced-search-history-table.component';
import { AdvancedSearchRecordTableComponent } from './advanced-search/advanced-search-record-table/advanced-search-record-table.component';
import { QueryPickerModule, SolCommonModule } from '@soleran/common';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatTableModule } from '@angular/material/table';
import { FormatModule } from '@soleran/module';
import { SolFormsModule } from '@soleran/forms';
import { MatDividerModule } from '@angular/material/divider';
import { MatIconModule } from '@angular/material/icon';
import { MatListModule } from '@angular/material/list';
import { ModulePickerComponent } from '../module-picker/module-picker.component';
import { MatChipsModule } from '@angular/material/chips';
import { ModuleIconModule } from '../module-icon/module-icon.module';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';

@NgModule({
  declarations: [
    GlobalSearchComponent,
    GlobalSearchHistoryResultsComponent,
    GlobalSearchRecordResultsComponent,
    AdvancedSearchComponent,
    AdvancedSearchDialogComponent,
    AdvancedSearchHistoryTableComponent,
    AdvancedSearchRecordTableComponent,
    ModulePickerComponent,
  ],
  imports: [
    SolCommonModule,
    SolFormsModule,
    FormatModule,
    QueryPickerModule,
    MatProgressSpinnerModule,
    MatChipsModule,
    MatFormFieldModule,
    MatInputModule,
    MatPaginatorModule,
    MatTableModule,
    MatDividerModule,
    MatIconModule,
    MatListModule,
    MatButtonModule,
    RouterModule,
    SearchModuleModule,
    UserHistoryModule,
    ModuleIconModule,
  ],
  exports: [GlobalSearchComponent],
  providers: [
    GlobalSearchService,
    AdvancedSearchService,
    GlobalSearchHistoryResultsComponent,
  ],
})
export class GlobalSearchModule {}
